import React from "react"

import { makeStyles } from "../utils/styles/makeStyles"

import styles from "./styles"

interface IDimmedProps {
    children: React.ReactNode
}

const useStyles = makeStyles(styles, "Dimmed", true)
export const Dimmed: React.FC<IDimmedProps> = (props) => {
    const classes = useStyles()

    return <span className={classes.dimmed}>{props.children}</span>
}
